import { render, staticRenderFns } from "./TwoFactorSetupApp.vue?vue&type=template&id=06bd848c&"
import script from "./TwoFactorSetupApp.vue?vue&type=script&lang=js&"
export * from "./TwoFactorSetupApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports